<template>
  <b-card body-bg-variant="light"
          header="Preferred time of the experiment"
          header-bg-variant="dark"
          header-text-variant="light">
    <date-range v-model="data.general.preferred_time"
                :disabled="!editable"
                title="Preferred time"
                @input="compareDates($event, 0)"/>
    <hr>
    <date-range v-model="data.general.undesirable_period"
                :disabled="!editable"
                title="Undesirable period"
                @input="compareDates($event, 1)"/>
  </b-card>
</template>

<script>
  import dateRange from '@/components/proposal/proposals/date_range';
  import moment from 'moment';

  export default {
    name: 'PreferredTime',
    props: {
      value: undefined,
      editable: {
        type: Boolean,
        default: true,
      },
    },
    components: { dateRange },
    data() {
      return { data: this.value };
    },
    methods: {
      compareDates(event, component) {
        if (event) {
          let eventDatesRange = [];
          let datesToCompareRange = [];
          let sameDate = false;
          const undesirable = this.data.general.undesirable_period;
          const preferred = this.data.general.preferred_time;
          if (undesirable && preferred && undesirable.length !== 0 && preferred.length !== 0) {
            // event is returned as array so it is iterated
            event.forEach((el) => {
              const datesToCompare = (
                component === 0 ? this.data.general.undesirable_period : this.data.general.preferred_time
              );
              eventDatesRange = this.getDatesRange(el[0], el[1]);
              datesToCompare.forEach((ele) => {
                datesToCompareRange = this.getDatesRange(ele[0], ele[1]);
                if (sameDate === false) {
                  sameDate = datesToCompareRange.some((r) => eventDatesRange.includes(r));
                }
              });
            });
          }
          if (sameDate) {
            this.$notify({
              type: 'error',
              title: 'Preferred time and undesirable period dates are identical ',
            });
          }
        }
      },
      getDatesRange(startDate, stopDate) {
        // build array of days between startDate and stopDate included, ex. [a,d] to [a,b,c,d]
        const dateArray = [];
        let currentDate = moment(startDate);
        const stopDateMoment = moment(stopDate);
        while (currentDate <= stopDateMoment) {
          dateArray.push(moment(currentDate).format('YYYY-MM-DD'));
          currentDate = moment(currentDate).add(1, 'days');
        }
        return dateArray;
      },
    },
    watch: {
      value: {
        handler() {
          this.data = this.value;
          if (this.data.general === undefined) this.data.general = {};
        },
        deep: true,
      },
      'data.general.preferred_time': {
        handler() {
          if (this.data.general.preferred_time?.length === 0) {
            delete this.data.general.preferred_time;
          }
        },
      },
      'data.general.undesirable_period': {
        handler() {
          if (this.data.general.undesirable_period?.length === 0) {
            delete this.data.general.undesirable_period;
          }
        },
      },
    },
  };
</script>
